/* Altri prodotti dello stesso brand.
   Carica /collections/vendors?q=VENDOR via Section Rendering API,
   rimuove il prodotto corrente e mostra la griglia (stessa card dei correlati). */
(function () {
  if (customElements.get('brand-products')) return;

  customElements.define(
    'brand-products',
    class extends HTMLElement {
      connectedCallback() {
        this.vendor = this.getAttribute('data-vendor');
        this.handle = this.getAttribute('data-product-handle');
        this.limit = parseInt(this.getAttribute('data-limit'), 10) || 4;
        this.grid = this.querySelector('[data-brand-grid]');
        this.heading = this.querySelector('[data-brand-heading]');
        if (!this.vendor || !this.grid) {
          this.remove();
          return;
        }
        this.load();
      }

      load() {
        let url =
          '/collections/vendors?q=' +
          this.vendor +
          '&section_id=brand-products';

        // in anteprima tema: propaga preview_theme_id alla Section Rendering API
        const preview = new URLSearchParams(window.location.search).get(
          'preview_theme_id'
        );
        if (preview) url += '&preview_theme_id=' + preview;

        fetch(url)
          .then((r) => (r.ok ? r.text() : Promise.reject()))
          .then((html) => this.render(html))
          .catch(() => this.remove());
      }

      render(html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const tpl = doc.querySelector('[data-api-brand-template]');
        if (!tpl) {
          this.remove();
          return;
        }

        // rimuove la card del prodotto corrente
        if (this.handle) {
          tpl
            .querySelectorAll('a[href*="/products/' + this.handle + '"]')
            .forEach((a) => {
              const card = a.closest('.product-item');
              if (card) card.remove();
            });
        }

        const items = tpl.querySelectorAll('.product-item');
        if (!items.length) {
          this.remove();
          return;
        }

        // limita al numero richiesto
        items.forEach((item, i) => {
          if (i >= this.limit) item.remove();
        });

        const gridSlider = tpl.querySelector('grid-slider') || tpl.firstElementChild;
        if (!gridSlider) {
          this.remove();
          return;
        }

        // se restano pochi item, disabilita lo slider (come i correlati)
        const remaining = tpl.querySelectorAll('.product-item').length;
        const innerGrid = tpl.querySelector('[data-grid-slider]');
        if (innerGrid && remaining <= 4) {
          innerGrid.classList.add('grid--slider-disabled');
        }

        this.grid.innerHTML = tpl.innerHTML;
        if (this.heading) this.heading.hidden = false;

        // inizializza lo slider del tema sul nuovo grid
        const newGrid = this.grid.querySelector('[data-grid-slider]');
        if (newGrid) {
          newGrid.dispatchEvent(
            new CustomEvent('theme:grid-slider:init', { bubbles: true })
          );
        }
      }
    }
  );
})();
